var map = {
	"./demos/basic/index.ts": 88724,
	"./demos/disabled/index.ts": 88614,
	"./demos/ghost/index.ts": 42174,
	"./demos/group/index.ts": 10721,
	"./demos/icon/index.ts": 12680,
	"./demos/loading/index.ts": 30576,
	"./demos/size/index.ts": 9368,
	"./demos/tagName/index.ts": 12474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71015;